import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react';

interface PhotoGuideState {
  isShowCompactPhotoGuidance: boolean;
}

interface PhotoGuideContextValue {
  state: PhotoGuideState;
  setIsShowCompactPhotoGuidance: (value: boolean) => void;
}

const PhotoGuideContext = createContext<PhotoGuideContextValue | undefined>(undefined);

interface PhotoGuideProviderProps {
  children: ReactNode;
}

export const PhotoGuideProvider: React.FC<PhotoGuideProviderProps> = ({ children }) => {
  const [isShowCompactPhotoGuidance, setIsShowCompactPhotoGuidance] = useState(false);

  const value = useMemo<PhotoGuideContextValue>(
    () => ({
      state: { isShowCompactPhotoGuidance },
      setIsShowCompactPhotoGuidance,
    }),
    [isShowCompactPhotoGuidance],
  );

  return <PhotoGuideContext.Provider value={value}>{children}</PhotoGuideContext.Provider>;
};

export const usePhotoGuideContext = (): PhotoGuideContextValue => {
  const context = useContext(PhotoGuideContext);
  if (context === undefined) {
    throw new Error('usePhotoGuideContext must be used within a PhotoGuideProvider');
  }
  return context;
};

export default PhotoGuideContext;
